import { AuthState } from '@core/store/auth/auth.state';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';

export function initializeApp(store: Store) {
  return (): Promise<boolean> => {
    return firstValueFrom(store.select(AuthState.isLoaded).pipe(filter(Boolean))); /// wait for load auth state, init app
  };
}
